import { NavLink } from 'react-router-dom';
import { FileText, Network, Users, Settings as SettingsIcon, Trash2, LogOut } from 'lucide-react';
import { authApi } from '../api/auth';
import { useNavigate } from 'react-router-dom';
import { toast } from './Toast';

const NAV_ITEMS = [
  { to: 'docs', label: '文档', icon: FileText },
  { to: 'mindmaps', label: '导图', icon: Network },
  { to: 'members', label: '成员', icon: Users },
  { to: 'settings', label: '设置', icon: SettingsIcon },
  { to: 'trash', label: '回收站', icon: Trash2 },
];

/**
 * 左侧栏：主导航 + 退出
 */
export function Sidebar() {
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await authApi.logout();
    } catch {
      // ignore
    }
    localStorage.removeItem('ws_token');
    toast.success('已退出登录');
    navigate('/login');
  }

  return (
    <aside className="flex w-56 flex-col border-r border-border bg-bg-surface/95 backdrop-blur-sm">
      <nav className="flex flex-col gap-0.5 px-3 py-5">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex h-9 items-center gap-2.5 rounded-lg px-3 text-sm transition-all duration-fast ${
                isActive
                  ? 'bg-accent-50 text-accent font-medium'
                  : 'text-text-secondary hover:bg-bg-subtle hover:text-text-primary'
              }`
            }
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="mt-auto border-t border-border/60 px-3 py-3">
        <button
          type="button"
          onClick={handleLogout}
          className="flex h-9 w-full items-center gap-2.5 rounded-lg px-3 text-sm text-text-secondary hover:bg-bg-subtle hover:text-danger transition-all duration-fast"
          aria-label="退出登录"
        >
          <LogOut className="h-4 w-4" />
          退出登录
        </button>
      </div>
    </aside>
  );
}